import {
  ADD_NEW_TICKET,
  ADD_NEW_TICKET_SUCCESS,
  ADD_NEW_TICKET_FAIL,
  GETTING_TICKET_CONTENT_DATA,
  GETTING_TICKET_CONTENT_DATA_SUCCESS,
  GETTING_TICKET_CONTENT_DATA_FAILED,
  TICKET_DETAILS_LISTING_DATA,
  TICKET_DETAILS_LISTING_DATA_SUCCESS,
  TICKET_DETAILS_LISTING_DATA_FAILURE,
  TICKET_CITIES_SUGGESTION_DATA,
  TICKET_CITIES_SUGGESTION_DATA_SUCCESS,
  TICKET_CITIES_SUGGESTION_DATA_FAILURE,
} from "../Constants/ticketManagementConstant";
import { request } from "utils/request";
import {
  addNewTicketActionApi,
  ticketCatgeoryJson,
  aemContentPath,
  ticketCategoryListing,
  ticketCitiesSuggestionJson,
} from "Constant/apiConstant";
import { displayNotification } from "store/action";
import axios from "axios";

const errorResponse = (dispatch) => {
  dispatch(
    displayNotification({
      open: true,
      message: "Something went wrong.",
      duration: 6000,
      severity: "error",
    })
  );
};

const sucessfullResponse = (dispatch, msg) => {
  dispatch(
    displayNotification({
      open: true,
      message: msg ? msg : "Successfully.",
      duration: 6000,
      severity: "success",
    })
  );
};

const addNewTicketActionStart = () => {
  return { type: ADD_NEW_TICKET };
};
const addNewTicketActionSuccess = (payload) => {
  return { type: ADD_NEW_TICKET_SUCCESS, payload };
};
const addNewTicketActionError = (error) => {
  return { type: ADD_NEW_TICKET_FAIL, error };
};

export const gettingTicketContentData = () => {
  return {
    type: GETTING_TICKET_CONTENT_DATA,
  };
};

const ticketListingData = () => {
  return { type: TICKET_DETAILS_LISTING_DATA };
};

const ticketListingDataSuccess = (payload) => {
  return { type: TICKET_DETAILS_LISTING_DATA_SUCCESS, payload };
};

const ticketListingDataFailure = (error) => {
  return { type: TICKET_DETAILS_LISTING_DATA_FAILURE, error };
};

const gettingTicketCitiesSuggestionData = () => {
  return { type: TICKET_CITIES_SUGGESTION_DATA };
};

const gettingTicketCitiesSuggestionDataSuccess = (payload) => {
  return { type: TICKET_CITIES_SUGGESTION_DATA_SUCCESS, payload };
};
const gettingTicketCitiesSuggestionDataFailed = () => {
  return { type: TICKET_CITIES_SUGGESTION_DATA_FAILURE };
};

export const gettingTicketContentDataSuccess = (payload) => {
  return {
    type: GETTING_TICKET_CONTENT_DATA_SUCCESS,
    payload: payload,
  };
};

export const gettingTicketContentDataFailed = () => {
  return {
    type: GETTING_TICKET_CONTENT_DATA_FAILED,
  };
};

const addNewTicketAction = (payload, callback) => (dispatch, getState) => {
  dispatch(addNewTicketActionStart());
  try {
    let url = addNewTicketActionApi;
    request("POST", url, payload, false)
      .then((res) => {
        console.log("pending response", res);
        if (res?.code === 200) {
          dispatch(addNewTicketActionSuccess(res?.data));
          callback && callback(res?.data);
          sucessfullResponse(dispatch, res?.message);
        } else {
          dispatch(addNewTicketActionError(res));
          errorResponse(dispatch);
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch(addNewTicketActionError(err));
        errorResponse(dispatch);
      });
  } catch (error) {
    dispatch(addNewTicketActionError("Something went wrong"));
    errorResponse(dispatch);
  }
};

const getTicketContentData = () => async (dispatch, getState, api) => {
  dispatch(gettingTicketContentData());

  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_ENDPOINT}${aemContentPath}${ticketCatgeoryJson}`
    );

    if (response.status === 200) {
      dispatch(gettingTicketContentDataSuccess(response.data.data));
    } else {
      dispatch(gettingTicketContentDataFailed());
    }
  } catch {
    dispatch(gettingTicketContentDataFailed());
  }
};

const ticketManagementListing = (payload) => (dispatch, getState) => {
  dispatch(ticketListingData());

  try {
    request(
      "GET",
      `${addNewTicketActionApi}?email=${payload?.email}&phone=${payload?.phone}&status=${payload.categories}&limit=${payload.limit}&page=${payload.page}`
    ).then((res) => {
      if (res?.code === 200) {
        dispatch(ticketListingDataSuccess(res));
      } else {
        dispatch(ticketListingDataFailure());
      }
    });
  } catch {
    dispatch(ticketListingDataFailure());
  }
};

const getTicketCitiesSuggestionData = () => async (dispatch, getState, api) => {
  dispatch(gettingTicketCitiesSuggestionData());

  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_ENDPOINT}${aemContentPath}${ticketCitiesSuggestionJson}`
    );

    if (response.status === 200) {
      console.log("eeee22222222", response.data.data);

      dispatch(gettingTicketCitiesSuggestionDataSuccess(response.data.data));
    } else {
      dispatch(gettingTicketCitiesSuggestionDataFailed());
    }
  } catch {
    dispatch(gettingTicketCitiesSuggestionDataFailed());
  }
};

export {
  addNewTicketAction,
  getTicketContentData,
  ticketManagementListing,
  getTicketCitiesSuggestionData,
};
